import { axiosObject } from "../config";
import { webStore } from "store";


function createSubscription(data: any) {
    return new Promise((resolve, reject) => {
        const currentUser: any = webStore.getState().auth.user;
        const email: any = webStore.getState().auth.userEmail;

        let uri = "auction/data/resource/subscriptions/_create";
        let payload = {
            user_uuid: currentUser.uuid,
            email: email,
            amount: data.amount,
            plan: data
        }

        axiosObject
            .post(uri, payload)
            .then((response) => {
                if (response.data.initiate_transaction_data?.body?.resultInfo?.resultStatus === "S") {
                    resolve(response.data);
                } else {
                    reject(response.data.initiate_transaction_data?.body?.resultInfo)
                }
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

function updateSubscription(data: any) {
    return new Promise((resolve, reject) => {
        let uri = "auction/data/resource/subscriptions/_patch";

        axiosObject
            .post(uri, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

function getSubscriptionByUserUuid(uuid: string) {
    return new Promise((resolve, reject) => {
        let uri = "auction/data/resource/subscriptions/_read";

        let payload = {
            apiConfig: {
                includeRelations: "*",
                includeMutations: "*"
            },
            limitBy: {
                per_page: 10,
                page: 1
            },
            sortBy: [],
            filterBy: [
                {
                    attribute: "status",
                    op: "eq",
                    value: "active"
                },
                {
                    attribute: "payment_status",
                    op: "eq",
                    value: "paid"
                },
                {
                    attribute: "user_uuid",
                    op: "eq",
                    value: uuid
                },
            ]
        }

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data.data[0]);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}


export { createSubscription, updateSubscription, getSubscriptionByUserUuid };
